var Shopify = Shopify || {};
Shopify.money_format = '${{amount_no_decimals}}';
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);
  function defaultOption(opt, def) { return (typeof opt == 'undefined' ? def : opt); }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');
    if (isNaN(number) || number == null) { return 0; }
    number = (number/100.0).toFixed(precision);
    var parts = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents = parts[1] ? (decimal + parts[1]) : '';
    return dollars + cents;
  }
  var match = formatString.match(placeholderRegex);
  var token = match ? match[1] : 'amount';
  switch (token) {
    case 'amount': value = formatWithDelimiters(cents, 2); break;
    case 'amount_no_decimals': value = formatWithDelimiters(cents, 0); break;
    case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break;
    case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break;
    default: value = formatWithDelimiters(cents, 2); break;
  }
  return formatString.replace(placeholderRegex, value);
};

const addItemToCart = async (itemId, quantity) => {
  const item = { id: itemId, quantity: quantity };
  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(item)
    });
    if (!response.ok) throw new Error('Network response was not ok');
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: {}, sections: ['cart-drawer', 'cart-icon-bubble'] })
    })
    .then((res) => res.json())
    .then((cartData) => {
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.renderContents === 'function') drawer.renderContents(cartData);
      var drawerEl = document.querySelector('cart-drawer.drawer');
      if (drawerEl) drawerEl.classList.remove('is-empty');
      if (typeof hcScarpaGuard === 'function') hcScarpaGuard(cartData);
      if (typeof hcScarpaBindFormSubmitGuards === 'function') hcScarpaBindFormSubmitGuards();
    });
    await response.json();
  } catch (error) { alert(error); }
};

const addItemToCartWithProperties = async (itemId, quantity, properties) => {
  const item = { id: itemId, quantity: quantity, properties: properties || {} };
  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(item)
    });
    if (!response.ok) throw new Error('Network response was not ok');
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: {}, sections: ['cart-drawer', 'cart-icon-bubble'] })
    })
    .then((res) => res.json())
    .then((cartData) => {
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.renderContents === 'function') drawer.renderContents(cartData);
      var drawerEl = document.querySelector('cart-drawer.drawer');
      if (drawerEl) drawerEl.classList.remove('is-empty');
      if (typeof hcScarpaGuard === 'function') hcScarpaGuard(cartData);
      if (typeof hcScarpaBindFormSubmitGuards === 'function') hcScarpaBindFormSubmitGuards();
    });
    await response.json();
  } catch (error) { alert(error); }
};

(function(){
  if (window.__HC_MODAL_WIRED__) return;
  window.__HC_MODAL_WIRED__ = true;
  function getOverlay(){ return document.querySelector('[data-hc-modal-overlay]'); }
  function getCloseBtn(){ return document.querySelector('[data-hc-close]'); }
  function closeOverlay(){
    var o = getOverlay();
    if (o) o.classList.remove('hc-open');
    var root = document.querySelector('.hc-modal-root');
    if (root) root.classList.remove('hc-open');
  }
  function wireHandlers(){
    var overlay = getOverlay();
    if (!overlay) return;
    var closeBtn = getCloseBtn();
    if (closeBtn) closeBtn.addEventListener('click', closeOverlay);
    overlay.addEventListener('click', function(e){ if (e.target === overlay) closeOverlay(); });
    document.addEventListener('keydown', function(e){ if (e.key === 'Escape') closeOverlay(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', wireHandlers);
  else wireHandlers();
})();

function hcIsBreezeProductTags(tagsStringLower) {
  if (!tagsStringLower) return false;
  return tagsStringLower.indexOf('breeze block') !== -1 ||
    tagsStringLower.indexOf('breeze') !== -1 ||
    tagsStringLower.indexOf('breeze_block') !== -1;
}

async function hcCanAddSampleFromPdp(sampleType, baseHandle) {
  try {
    var script = document.getElementById('hc-sample-limits');
    if (!script) return true;
    var cfg;
    try {
      cfg = JSON.parse(script.textContent || script.innerHTML || '{}');
    } catch(e) {
      return true;
    }
    if (!cfg || typeof cfg !== 'object') return true;
    var isTrade = !!cfg.isTrade;
    var matrix = isTrade ? cfg.tradeCustomer : cfg.regularCustomer;
    if (!matrix) return true;

    var cartUrlJs =
      (window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js';
    var res = await fetch(cartUrlJs, { cache: 'no-store' });
    if (!res.ok) return true;
    var cart = await res.json();
    if (!cart || !Array.isArray(cart.items)) return true;

    var items = cart.items;
    var sampleMeta = [];
    items.forEach(function(item) {
      var handle = item.handle || '';
      var title = (item.title || item.product_title || '').toLowerCase();
      var isSample =
        handle.endsWith('-sample') ||
        title.indexOf('sample') !== -1;
      if (!isSample) return;
      var base = handle;
      if (base.endsWith('-sample')) {
        base = base.slice(0, -7);
      }
      sampleMeta.push({ item: item, baseHandle: base });
    });

    if (!sampleMeta.length && !baseHandle) return true;

    var handles = [];
    sampleMeta.forEach(function(m) {
      if (m.baseHandle && handles.indexOf(m.baseHandle) === -1) {
        handles.push(m.baseHandle);
      }
    });
    if (baseHandle && handles.indexOf(baseHandle) === -1) {
      handles.push(baseHandle);
    }

    var tagMap = {};
    if (handles.length) {
      await Promise.all(
        handles.map(function(h) {
          var url = '/products/' + encodeURIComponent(h) + '.js';
          return fetch(url, { cache: 'no-store' })
            .then(function(r) {
              if (!r.ok) return null;
              return r.json();
            })
            .then(function(p) {
              if (!p || !p.handle) return;
              var tagsField = p.tags || '';
              var tagsString = Array.isArray(tagsField) ? tagsField.join(',') : String(tagsField);
              var lower = tagsString.toLowerCase();
              tagMap[p.handle] = lower;
              tagMap[p.handle.toLowerCase()] = lower;
            })
            .catch(function(){});
        })
      );
    }

    var regularCount = 0;
    var scarpaCount = 0;
    var breezeCount = 0;

    sampleMeta.forEach(function(m) {
      var qty = parseInt(m.item.quantity || 0, 10);
      if (!qty || qty <= 0) return;
      var tagsLower = tagMap[m.baseHandle] || tagMap[m.baseHandle.toLowerCase()] || '';
      var isScarpa =
        tagsLower.indexOf('carlo_scarpa') !== -1 ||
        tagsLower.indexOf('carlo-scarpa') !== -1;
      var isBreeze = hcIsBreezeProductTags(tagsLower);
      if (isScarpa) {
        scarpaCount += qty;
      } else {
        regularCount += qty;
      }
      if (isBreeze) {
        breezeCount += qty;
      }
    });

    var tagsLowerBase = '';
    if (baseHandle) {
      tagsLowerBase = tagMap[baseHandle] || tagMap[baseHandle.toLowerCase()] || '';
    }
    var baseIsScarpa =
      tagsLowerBase.indexOf('carlo_scarpa') !== -1 ||
      tagsLowerBase.indexOf('carlo-scarpa') !== -1;
    var baseIsBreeze = hcIsBreezeProductTags(tagsLowerBase);

    if (sampleType === 'scarpa' || baseIsScarpa) {
      scarpaCount += 1;
    } else {
      regularCount += 1;
      if (sampleType === 'breeze' || baseIsBreeze) {
        breezeCount += 1;
      }
    }

    var hasRegular = regularCount > 0;
    var hasScarpa = scarpaCount > 0;
    if (!hasRegular && !hasScarpa) return true;

    var breezeLimit = parseInt(matrix.breeze, 10);
    if (breezeLimit && !isNaN(breezeLimit) && breezeLimit > 0 && breezeCount > breezeLimit) {
      if (typeof hcShowSampleLimitModal === 'function') {
        hcShowSampleLimitModal();
      } else {
        alert('Sample limit reached');
      }
      return false;
    }

    var limit = 0;
    if (hasRegular && hasScarpa) {
      limit = parseInt(matrix.mixed, 10);
    } else if (hasScarpa) {
      limit = parseInt(matrix.scarpaOnly, 10);
    } else if (hasRegular) {
      limit = parseInt(matrix.regularOnly, 10);
    }
    if (!limit || isNaN(limit) || limit <= 0) return true;

    var totalSamples = regularCount + scarpaCount;
    if (totalSamples <= limit) return true;

    if (typeof hcShowSampleLimitModal === 'function') {
      hcShowSampleLimitModal();
    } else {
      alert('Sample limit reached');
    }

    return false;
  } catch(e) {
    return true;
  }
}

document.addEventListener('DOMContentLoaded', function() {
  var hcSampleButtons = document.querySelectorAll('.hc-sample');
  if (!hcSampleButtons.length) return;

  hcSampleButtons.forEach(function(btn) {
    btn.addEventListener('click', async function(e) {
      e.preventDefault();
      var v = parseInt(btn.getAttribute('data-variant'), 10);
      if (!v) return;
      var sampleType = btn.getAttribute('data-sample-type') || 'regular';
      var baseHandle = btn.getAttribute('data-base-handle') || '';
      var allowed = await hcCanAddSampleFromPdp(sampleType, baseHandle);
      if (!allowed) return;
      addItemToCart(v, 1);
    });
  });
});

(function(){
  function i(v){ v=parseInt(v,10); return isNaN(v)?0:v; }
  function f(v){ v=parseFloat(v); return isNaN(v)?0:v; }
  function recompute(input){
    var wrap=input.closest('.hc-ft-calculator-wrapper');
    var over=(wrap&&wrap.querySelector('.hc-overage'))||document.querySelector('.hc-overage');
    var price=i(input.getAttribute('data-price'));
    var fq=i(input.getAttribute('data-fq-box'));
    var calc=(wrap&&wrap.getAttribute('data-calculation'))||'ft';
    var priceEl=document.querySelector('.price__container .price-item');
    var qty=document.querySelector('.price-per-item__container .quantity__input');
    var totalFt=document.querySelector('.hc-total-ft');
    var totalBoxes=document.querySelector('.hc-total-boxes');
    var base=f(input.value); if(!base) return;
    var pct=0; if(over){ var raw=(over.value||'').trim(); pct=(raw.toLowerCase()==='overage')?0:i(raw); }
    var overFT=Math.ceil(base + (pct/100)*base);
    var boxes=fq>0?Math.ceil(overFT/fq):0;
    var aux=(calc==='box')?boxes:overFT;
    if(qty) qty.value=aux;
    if(priceEl) priceEl.innerText=Shopify.formatMoney((aux*price), Shopify.money_format);
    if(totalFt) totalFt.innerText=overFT;
    if(totalBoxes) totalBoxes.innerText=boxes;
  }
  document.addEventListener('input', function(e){ var el=e.target.closest('.hc-ft-needed'); if(el) recompute(el); });
  document.addEventListener('change', function(e){
    if(e.target.matches('.hc-overage')){ var el=document.querySelector('.hc-ft-needed'); if(el && String(el.value).trim()!=='') recompute(el); }
    var el2=e.target.closest('.hc-ft-needed'); if(el2) recompute(el2);
  });
})();
